<style scoped>
@media screen and (max-width: 640px){
  .container{
    width: 100% !important;
  }
  .c-title{
    padding: 20px 0 20px!important;
    font-size: 18px!important;
  }
}
@media screen and (max-width: 641px){
  .breads{
    display: none!important;
  }
}
</style>
<template>
  <div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
      <bread></bread>
    </div>
    <div class="c-title">发展历程</div>
    <div class="container">
      <img src="@/assets/img/developmentHistory.png" class="img-fluid">
    </div>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/summary/develop.vue